import { render, staticRenderFns } from "./TablaResumenInversion.vue?vue&type=template&id=06b1e648&scoped=true"
import script from "./TablaResumenInversion.vue?vue&type=script&lang=js"
export * from "./TablaResumenInversion.vue?vue&type=script&lang=js"
import style0 from "./TablaResumenInversion.vue?vue&type=style&index=0&id=06b1e648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1e648",
  null
  
)

export default component.exports